module.exports = __webpack_public_path__ + "static/media/listeningWitnessImage.b605be95.webp";